'use strict';
import _ from 'underscore';
import angular from 'angular';
var CartItemListController = /** @class */ (function () {
    /*@ngInject*/
    function CartItemListController($scope, Auth, $log, $state, CartService, $q, $rootScope, Util, $filter, UserService, CommonDataService, AddressService) {
        var _this = this;
        this.type = "name";
        this.types = [
            { value: "name", text: "No Grouping" },
            { value: "brandCode", text: "Sort By Brand" },
        ];
        this.showItem = true;
        this.currentIndex = null;
        this.showAlert = true;
        //loadingBar = true;
        this.loadingQuantity = null;
        this.removingItem = null;
        this.editUnitPrice = false;
        this.overrideCSAProduct = [];
        this.loadingExpressCheckoutNextStep = false;
        this.disableExpressCheckout = true;
        this.isLoggedIn = function () {
            if (this.loggedInUser) {
                return true;
            }
            return false;
        };
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.goExpressCheckout = function () {
            this.loadingExpressCheckoutNextStep = true;
            console.log('Did BROADCASTs THE EXPRESS CHECKOUT MOBILE EVENT');
            this.$rootScope.$broadcast('express-checkout-mobile');
        };
        this.errors = {};
        this.clearQuantity = function (itemId) {
            this.items.forEach(function (item) {
                if (item.itemId == itemId) {
                    item.quantity = '';
                }
            });
        };
        this.removeCurrentItem = function (item) {
            this.setCurrentIndex(item.itemId);
            this.confirmRemove(item);
        };
        this.CartService = CartService;
        this.UserService = UserService;
        this.Auth = Auth;
        this.$log = $log;
        this.$state = $state;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.Util = Util;
        this.$scope = $scope;
        this.$filter = $filter;
        this.itemLevelErrors = this.CartService.itemLevelErrors;
        this.commonDataService = CommonDataService;
        this.AddressService = AddressService;
        var self = this;
        this.loadingBar = true;
        this.loggedInUser = false;
        this.subscribedToCart = false;
        this.blockCheckOut = false;
        // use $q.when to force this function to return a promise
        this.$q.when(this.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.$log.info('In cart..current user is..', loggedInUser);
                self.loggedInUser = loggedInUser;
            }
        }))
            .then(function (data) {
            // when data is equal to null the user is not logged in and the loadingBar should stop
            // when it's undefined or is an object with properties then the user is logged in
            // and the cart service will handle the loading state
            if (data === null) {
                _this.loadingBar = false;
            }
        });
        // allow other api events (addItems post) to finish before executing CartService.subscribe
        // so that the loading spinner is shown until all calls are back
        var getCartWatch = $scope.$watch(function () { return _this.CartService.getActivePromises(); }, function (newVal, oldVal) {
            if (oldVal > 0 && newVal === 0 && !_this.subscribedToCart) {
                getCartWatch(); // destroy this watch
                var isNewRequest = true;
                _this.CartService._getCart(isNewRequest)
                    .then(function (response) {
                    // this will update cart data and emit cart retrieved event, which will update express checkout status;
                    _this.CartService.setNewCart(response.data.response);
                    response.data.response.aresLineItems.forEach(function (arr) {
                        var orderLevelDiscount = [];
                        arr.orderLevelDiscounts.forEach(function (discount) {
                            if (discount.discountName.indexOf("_WELL") !== 0) {
                                orderLevelDiscount.push(discount);
                            }
                        });
                        arr.orderLevelDiscounts = orderLevelDiscount;
                    });
                    _this.loadingBar = false;
                    _this.items = response.data.response.aresLineItems;
                    _this.commonDataService.addAttributeProductPathsForAllItems(_this.items);
                    _this.loadingQuantity = null;
                });
            }
        });
    }
    CartItemListController.prototype.setCurrentIndex = function (id) {
        this.currentIndex = this.currentIndex == id ? null : id;
        this.showItem = false;
    };
    CartItemListController.prototype.$onInit = function () {
        var _this = this;
        var self = this;
        if (self.CartService.isItemRemoved) {
            if (self.CartService.restrictedItemIds.trim()) {
                self.showAlert = true;
                self.Util.setPageErrors('Product ' + self.CartService.restrictedItemIds + ' is restricted to Qualified Healthcare Professionals.', '', self);
            }
            self.CartService.restrictedItemIds = ' ';
            self.CartService.isItemRemoved = false;
        }
        self.UserService.get().then(function (user) {
            if (user.data.response) {
                _this.userInfo = user.data.response;
                _this.blockCheckOut = user.data.response.blockCheckOut;
            }
        })
            .catch(function (err) {
            console.log("cart-item-list get user error => " + err);
        });
        self.validateShippingAddress();
    };
    CartItemListController.prototype.validateShippingAddress = function () {
        var _this = this;
        this.AddressService.getAddresses()
            .then(function (response) {
            if (response.data && response.data.response && response.data.response.currentPage) {
                var allAddress = response.data.response.currentPage;
                var defaultAddress = allAddress.find(function (address) {
                    return address.isDefault == true;
                });
                if (defaultAddress && defaultAddress.countryCode) {
                    _this.disableExpressCheckout = !_this.AddressService.isValidShippingCountries(defaultAddress.countryCode);
                }
            }
        });
    };
    CartItemListController.prototype.cancelRemove = function () {
        this.currentIndex = null;
        this.showItem = true;
        this.errors.havePageErrors = false;
        this.removingItem = null;
    };
    CartItemListController.prototype.confirmRemove = function (item) {
        this.removeItem(item);
    };
    CartItemListController.prototype.decrement = function (id) {
        this.errors.havePageErrors = false;
        this.showAlert = false;
        this.currentIndex = null;
        var index = this.items.findIndex(function (item) { return item.itemId == id; });
        var quantity = this.items[index].quantity ? parseInt(this.items[index].quantity, 10) : 0;
        var minimumSaleQuantity = this.items[index].minimumSaleQuantity;
        var onHandQuantity = this.items[index].onHandQuantity;
        var isOnVendorBackOrder = this.items[index].isOnVendorBackOrder;
        var self = this;
        if (minimumSaleQuantity == 0) {
            if (quantity - 1 <= 0) {
                self.setCurrentIndex(id);
            }
            if (quantity - 1 > onHandQuantity) {
                self.bannerMessage("Item is available in limited quantities. If the quantity requested is more that what is available, the quantity will be reduced to the remaining quantity.");
            }
            quantity -= 1;
        }
        else {
            self.bannerMessage("Minimum Quantity Required. If the quantity requested is less that what is required, the quantity will be increased to the minimum quantity.");
            if (quantity - minimumSaleQuantity <= 0) {
                self.setCurrentIndex(id);
            }
            else {
                self.bannerMessage("Items sold in quantities of [multiple]. Quantities entered outside of the mandatory quantity values will be rounded up to the nearest available amount.");
                quantity = quantity % minimumSaleQuantity == 0 ? quantity - minimumSaleQuantity : quantity - (quantity % minimumSaleQuantity);
                if (quantity > onHandQuantity) {
                    self.bannerMessage("Item is available in limited quantities. If the quantity requested is more that what is available, the quantity will be reduced to the remaining quantity.");
                }
            }
        }
        self.items[index].quantity = quantity;
    };
    CartItemListController.prototype.increment = function (id) {
        // this.errors.havePageErrors = false;
        this.showAlert = false;
        this.currentIndex = null;
        var index = this.items.findIndex(function (item) { return item.itemId == id; });
        var quantity = this.items[index].quantity ? parseInt(this.items[index].quantity, 10) : 0;
        var minimumSaleQuantity = this.items[index].minimumSaleQuantity;
        var maximumSaleQuantity = this.items[index].maximumSaleQuantity;
        var onHandQuantity = this.items[index].onHandQuantity;
        var isOnVendorBackOrder = this.items[index].isOnVendorBackOrder;
        var self = this;
        if (maximumSaleQuantity == -1) {
            if (minimumSaleQuantity == 0) {
                quantity += 1;
            }
            else {
                if (quantity + minimumSaleQuantity > onHandQuantity) {
                    self.bannerMessage("Item is available in limited quantities. If the quantity requested is more that what is available, the quantity will be reduced to the remaining quantity.");
                    quantity = quantity % minimumSaleQuantity == 0 ? quantity + minimumSaleQuantity : quantity + (minimumSaleQuantity - quantity);
                }
                else {
                    self.bannerMessage("Items sold in quantities of [multiple]. Quantities entered outside of the mandatory quantity values will be rounded up to the nearest available amount.");
                    quantity += minimumSaleQuantity;
                }
            }
        }
        self.items[index].quantity = quantity;
    };
    CartItemListController.prototype.removeItem = function (itemToRemove) {
        var _this = this;
        if (this.limitedStockWarning && (this.limitedStockItemId === itemToRemove.itemId)) {
            this.limitedStockWarning = false;
            this.limitedStockItemId = null;
            this.showAlert = false;
        }
        this.$rootScope.$broadcast('removing item start');
        this.removingItem = this.CartService.removeItem(itemToRemove.itemId)
            .then(function (response) {
            _this.removingItem = null;
            _this.currentIndex = null;
            var itemIndex = _this.items.findIndex(function (item) { return item.itemId === itemToRemove.itemId; });
            if (itemIndex > -1) {
                var isNewRequest = true;
                _this.CartService._getCart(isNewRequest)
                    .then(function (response) {
                    _this.items = response.data.response.aresLineItems;
                    _this.commonDataService.addAttributeProductPathsForAllItems(_this.items);
                })
                    .catch(function () {
                    _this.loadingQuantity = null;
                });
            }
        })
            .catch(function () {
            _this.removingItem.error = true;
        })
            .finally(function () {
            _this.$rootScope.$broadcast('removing item end');
        });
    };
    CartItemListController.prototype.itemQuantity = function (id, quantity) {
        var _this = this;
        this.CartService.itemQuantity(id, quantity)
            .then(function (response) {
            if (response) {
                _this.handleWarningError(response);
                var isNewRequest = true;
                _this.CartService._getCart(isNewRequest)
                    .then(function (response) {
                    var updatedItem = _this.items.find(function (item) { return item.itemId === id; });
                    if (updatedItem) {
                        var responseUpdatedItem = response.data.response.aresLineItems.find(function (item) { return item.itemId === id; });
                        if (responseUpdatedItem) {
                            updatedItem.quantity = responseUpdatedItem.quantity;
                            updatedItem.totalPrice = responseUpdatedItem.totalPrice;
                            _this.items = response.data.response.aresLineItems;
                            _this.commonDataService.addAttributeProductPathsForAllItems(_this.items);
                        }
                    }
                    _this.CartService.setNewCart(response.data.response);
                    _this.loadingQuantity = null;
                })
                    .catch(function () {
                    _this.loadingQuantity = null;
                });
            }
        });
    };
    CartItemListController.prototype.updateQuantity = function (id, newQuantity) {
        if (!newQuantity) {
            return;
        }
        var index = this.items.findIndex(function (item) { return item.itemId == id; });
        var quantity = parseInt(this.items[index].quantity);
        var minimumSaleQuantity = this.items[index].minimumSaleQuantity;
        var maximumSaleQuantity = this.items[index].maximumSaleQuantity;
        var onHandQuantity = this.items[index].onHandQuantity;
        var isOnVendorBackOrder = this.items[index].isOnVendorBackOrder;
        var isBackOrder = this.items[index].backOrder;
        var isDiscontinued = this.items[index].isDiscontinued;
        var self = this;
        if (newQuantity == undefined || newQuantity == 0) {
            self.confirmRemove(id);
            return;
        }
        if (newQuantity !== undefined && (onHandQuantity > 0 || isBackOrder)) {
            // TODO: isDiscontinued item
            // if (isDiscontinued && newQuantity > onHandQuantity) {
            //   self.bannerMessage("Item Has Been Discontinued. Item is available in limited quantities. If the quantity requested is more that what is available, the quantity will be reduced to the remaining quantity.");
            // }
            if (newQuantity > onHandQuantity && onHandQuantity > 0) {
                if (!isOnVendorBackOrder) {
                    if (isDiscontinued) {
                        self.bannerMessage("Limited stock available (" + onHandQuantity + "). If the quantity requested is more than what is available, we will adjust your order to match availability.");
                    }
                    else {
                        self.bannerMessage("Limited stock available (" + onHandQuantity + "). The remainder of your order will ship on the earliest possible date.");
                        self.limitedStockWarning = true;
                        self.limitedStockItemId = id;
                    }
                }
                self.showAlert = true;
                this.itemQuantity(id, newQuantity);
                return;
            }
            else if (onHandQuantity <= 0) {
                //self.bannerMessage(id+" is out of stock and will ship on the earliest possible date.");
                //self.showAlert = true;
                this.itemQuantity(id, newQuantity);
                return;
            }
            else if (newQuantity < minimumSaleQuantity) {
                self.bannerMessage("Minimum Quantity Required. If the quantity requested is less that what is required, the quantity will be increased to the minimum quantity.");
                if (onHandQuantity < minimumSaleQuantity) {
                    self.bannerMessage("Item is available in limited quantities. If the quantity requested is more that what is available, the quantity will be reduced to the remaining quantity.");
                    newQuantity = newQuantity % minimumSaleQuantity == 0 ? newQuantity + minimumSaleQuantity : newQuantity + (minimumSaleQuantity - newQuantity);
                }
                else {
                    self.bannerMessage("Items sold in quantities of [multiple]. Quantities entered outside of the mandatory quantity values will be rounded up to the nearest available amount.");
                }
                this.itemQuantity(id, minimumSaleQuantity);
                self.items[index].quantity = minimumSaleQuantity;
                return;
            }
            else {
                this.itemQuantity(id, newQuantity);
            }
        }
        else if (newQuantity !== undefined && onHandQuantity <= 0) {
            //self.bannerMessage(id+" is out of stock and will ship on the earliest possible date.");
            //self.showAlert = true;
            this.itemQuantity(id, newQuantity); //minimumSaleQuantity
            return;
        }
    };
    CartItemListController.prototype.override = function (id, item) {
        this.overrideCSAProduct[id] = {
            editUnitPrice: true,
            unitPrice: this.$filter('currency')(item.unitPrice),
            loadingPrice: false
        };
    };
    CartItemListController.prototype.disableCartBtn = function (quantity) {
        if (!quantity) {
            return true;
        }
    };
    CartItemListController.prototype.applyOverriddenPrice = function (id, item) {
        var _this = this;
        var self = this;
        this.overrideCSAProduct[id].loadingPrice = true;
        var param = {
            "itemId": item.itemId,
            "price": this.overrideCSAProduct[id].unitPrice.replace('$', '')
        };
        this.CartService.overrideCSAPrice(param)
            .then(function (response) {
            _this.CartService._getCart(true).then(function (response) {
                self.items = response.data.response.aresLineItems;
                _this.CartService.setNewCart(response.data.response);
            })
                .catch(function (error) {
                console.log("CartItemListController err...", error);
            })
                .finally(function () {
                _this.overrideCSAProduct[id].editUnitPrice = false;
                _this.overrideCSAProduct[id].loadingPrice = false;
            });
        })
            .catch(function (error) {
            console.log("CartItemListController err...", error);
        });
    };
    CartItemListController.prototype.unitPriceInputBlur = function (event, id, item) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var classList = [];
        var applyPrice = true;
        if (event.relatedTarget) {
            classList = event.relatedTarget.classList;
        }
        _.filter(classList, function (className) { if (className == 'cancel-edit-price') {
            applyPrice = false;
        } });
        if (applyPrice) {
            this.applyOverriddenPrice(id, item);
        }
        this.overrideCSAProduct[id].editUnitPrice = false;
    };
    CartItemListController.prototype.cancelOverridingPrice = function (event, id) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.overrideCSAProduct[id].editUnitPrice = false;
    };
    CartItemListController.prototype.bannerMessage = function (message) {
        this.errors.pageErrorType = 'warning';
        this.errors.pageErrors = message;
        this.errors.havePageErrors = true;
    };
    CartItemListController.prototype.sumItemSubTotal = function (value) {
        var brandItemSubTotal = 0;
        value.forEach(function (ele) { return brandItemSubTotal += ele.totalPrice; });
        return brandItemSubTotal;
    };
    CartItemListController.prototype.sumQuantityItem = function (value) {
        var quantityItem = 0;
        value.forEach(function (ele) { return quantityItem += ele.quantity; });
        return quantityItem;
    };
    CartItemListController.prototype.handleWarningError = function (data) {
        var message = '';
        if (data.errors) {
            angular.forEach(data.errors, function (error) {
                message = message + error.message;
            });
        }
        if (data.warnings) {
            angular.forEach(data.warnings, function (warning) {
                message = message + warning.message;
            });
        }
        if (message.length) {
            this.bannerMessage(message);
        }
    };
    CartItemListController.prototype.resetAlertMessage = function () {
        this.showAlert = false;
    };
    return CartItemListController;
}());
export default CartItemListController;
//# sourceMappingURL=cart-item-list.controller.js.map